export default __webpack_public_path__ + "static/media/flexibility_affordability.81da55dc.png";